import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import TonnageModel from '../../Tonnage/models/TonnageModel';
import CargoModel from '../../Cargo/models/CargoModel';

export enum CheckDuplicateType {
    Tonnage = "Tonnage",
    Cargo = "Cargo"
}

interface CheckDuplicateReducer {
    checkDuplicateType: CheckDuplicateType,
    tonnageData: TonnageModel[],
    cargoData: CargoModel[],
    selectedIds: string[]
}

const initialState: CheckDuplicateReducer = {
    checkDuplicateType: CheckDuplicateType.Tonnage,
    tonnageData: [],
    cargoData: [],
    selectedIds: []
}

export const CheckDuplicateSlice = createSlice({
    name: "CheckDuplicate",
    initialState,
    reducers: {
        setCheckDuplicateType: (state, action: PayloadAction<CheckDuplicateType>) => {
            state.checkDuplicateType = action.payload;
        },
        setTonnageData: (state, action: PayloadAction<TonnageModel[]>) => {
            state.tonnageData = action.payload;
        },
        setCargoData: (state, action: PayloadAction<CargoModel[]>) => {
            state.cargoData = action.payload;
        },
        setSelectedIds: (state, action: PayloadAction<string[]>) => {
            state.selectedIds = action.payload;
        },
    }
});

export const CheckDuplicateSelector = createSelector(
    (state: RootState) => state.checkDuplicate,
    (data) => data
);

export const {
    setCheckDuplicateType,
    setTonnageData,
    setCargoData,
    setSelectedIds
} = CheckDuplicateSlice.actions;

export default CheckDuplicateSlice.reducer;